import React, { ReactElement } from 'react'

/**
 * In order to allow FullStory to record labels, we need to wrap them with a div that has the class
 * name "fs-unmask", this components clones the element and adds the class name to it.
 * @param Component React element to wrap with FullStory unmask
 * @returns
 */
export const withFullStoryUnmask = (Component: ReactElement) =>
  React.cloneElement(Component, {
    className: Component.props.className ? `${Component.props.className} fs-unmask` : 'fs-unmask',
  })
